import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DispatchPlannerComponent } from './dispatch-planner.component';
import { AddressImportDialogComponent } from './address-import-dialog.component';
import { RollerSoapImportDialogComponent } from './roller-soap-import-dialog.component';
import { DispatchPlannerEmailDialogComponent } from './dispatch-planner-email-dialog.component';
import { DispatchPlannerArticlesDialogComponent } from './dispatch-planner-articles-dialog.component';
import { DispatchPlannerErrorDialogComponent } from './dispatch-planner-error-dialog.component';

@NgModule({
  declarations: [
    DispatchPlannerComponent,
    AddressImportDialogComponent,
    RollerSoapImportDialogComponent,
    DispatchPlannerEmailDialogComponent,
    DispatchPlannerArticlesDialogComponent,
    DispatchPlannerErrorDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AgmCoreModule,
    DragDropModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule
  ],
  exports: [
    DispatchPlannerComponent
  ]
})
export class DispatchPlannerModule {}
